<template>
  <div>
    <cx-check-box :value.sync="showTooltip">显示提示框</cx-check-box>
    <div v-if="showTooltip">
      <p class="font14 mb16 mt16">提示框文字</p>
      <!-- 字体和颜色/字重和字号 -->
      <text-setting-update
        class="mb16"
        colorMode="chart"
        :fontColor.sync="tooltipFontColor"
        :fontFamily.sync="tooltipFontFamily"
        :fontSize.sync="tooltipFontSize"
        :fontWeight.sync="tooltipFontWeight"
      />
      <!--提示框背景颜色-->
      <p class="mt16 font14">提示框背景</p>
      <color-picker
        class="mt8"
        :color.sync="tooltipBackgroundColor"
        title=""
        titlePosition="allInOneLine"
      />
      <!--背景框圆角-->
      <slider-and-input
        class="mt16"
        v-if="checkType(tooltipExtraCss)"
        :value.sync="tooltipExtraCss"
        title="圆角"
        :sliderMax="100"
        suffix="px"
        inputWidth="small"
        inputHeight="small"
      />
    </div>
    <div v-if="showTooltip && hasAutoPlay" class="mt16">
      <cx-check-box :value.sync="isAutoPlayToolTip">自动轮播</cx-check-box>
      <slider-and-input
        class="mt16"
        v-if="isAutoPlayToolTip"
        :value.sync="autoPlayToolTipIntervalTime"
        title="停留时间"
        :sliderMax="10000"
        :sliderMin="1000"
        suffix="ms"
        inputWidth="small"
        inputHeight="small"
      />
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
import { checkAndSetPrimaryVal } from "../../../../../utils"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    showTooltip: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "tooltip.show", "tooltip.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.show", false)
      }
    },
    hasAutoPlay() {
      return this.options.hasOwnProperty("isAutoPlayToolTip")
    },
    isAutoPlayToolTip: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isAutoPlayToolTip", "isAutoPlayToolTip", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isAutoPlayToolTip", false)
      }
    },
    autoPlayToolTipIntervalTime: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "autoPlayToolTipIntervalTime",
          "autoPlayToolTipIntervalTime",
          1000
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "autoPlayToolTipIntervalTime", false)
      }
    },
    tooltipFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOpt,
          "tooltip.textStyle.fontFamily",
          "tooltip.textStyle.fontFamily",
          "sans-serif"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.textStyle.fontFamily", false)
      }
    },
    tooltipFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "tooltip.textStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.textStyle.color", false)
      }
    },
    tooltipFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "tooltip.textStyle.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.textStyle.fontWeight", false)
      }
    },
    tooltipFontSize: {
      get() {
        return this.hasProperty(this.chartOpt, "tooltip.textStyle.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.textStyle.fontSize", false)
      }
    },
    tooltipBackgroundColor: {
      get() {
        return this.hasProperty(this.chartOpt, "tooltip.backgroundColor")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.backgroundColor", false)
      }
    },
    tooltipExtraCss: {
      get() {
        let num = 0
        if (this.hasProperty(this.chartOpt, "tooltip.extraCssText")) {
          let txt = this.chartOpt.tooltip.extraCssText
          num = parseInt(txt.replace(/[^0-9]/gi, ""))
        }
        return num
      },
      set(newVal) {
        newVal = "border-radius: " + newVal + "px;"
        this.$changeOptionsEV(newVal, "chartOption.tooltip.extraCssText", false)
      }
    }
  }
}
</script>

<style scoped>
.color-picker-container.tooltip-bg-color {
  width: calc(100% - 78px);
}
</style>
